<template>
    <div class="u-mt-12">
        <g-loading v-show="loading"></g-loading>
        <div v-show="!loading">
            <div v-if="error_messate" class="error-msg-area">
                <p>{{ error_messate }}</p>
            </div>
            <div class="payment-method-block">
                <div class="payment-method-radio-block">
                    <input id="radio-1" class="c-input-radio" name="payment_method" type="radio" :disabled="!registed_card_number || is_brand_limit_adult"
                            v-model="selected_payment" value="registed_card">
                    <label for="radio-1">
                        <div class="payment-method-name">登録中のクレジットカード</div>
                        <div v-if="registed_card_number" class="payment-method-sub-info">{{ registed_card_number }}</div>
                        <div v-if="is_brand_limit_adult" class="annotation is-error">
                            <p>カートにアダルト商品があるので、VISA/MASTERはご利用になれません。</p>
                        </div>
                        <div v-else-if="!registed_card_number" class="payment-method-sub-info">ご利用可能なカードがありません。</div>
                    </label>
                </div>
            </div>
            <div class="payment-method-block">
                <div class="payment-method-radio-block">
                    <input id="radio-2" class="c-input-radio" name="payment_method" type="radio" v-model="selected_payment" value="new_card">
                    <label for="radio-2" :class="{ 'is-active': !registed_card_number, 'payment-type-accordion' : selected_payment !== 'new_card'}">
                        <div  class="payment-method-name">新規クレジットカード</div>
                    </label>
                </div>
                <form class="payment-method-block-detail" v-show="!registed_card_number || selected_payment === 'new_card'">
                    <div v-if="is_adult_content_included">
                        <img class="credit-card-image" src="/images/for-adult-credit-card.jpg" width="200">
                    </div>
                    <div v-else>
                        <img class="credit-card-image" src="/images/credit-card.jpg" width="200">
                    </div>

                    <div class="new-credit-card-form">
                        <label for="cardno">カード番号</label>
                        <div class="input-wrapper">
                            <input type="text" id="cardno" class="browser-default c-input-text" data-cy="payment-item_purchase-cardno" inputmode="numeric"
                                    autocomplete="cc-number" placeholder="1234 5678 9012 3456" required="required"
                                :class="{'is-error': (!newCardValids.cardno.isValid && isCheckNewCard) || isNewCardAdultLimitBrand}">
                            <div class="annotation is-error u-mt-2" v-if="!newCardValids.cardno.isValid && isCheckNewCard">10～16桁の半角数字で入力してください。</div>
                            <div class="annotation is-error u-mt-2" v-if="isNewCardAdultLimitBrand">カートにアダルト商品があるので、VISA/MASTERはご利用になれません。</div>
                            <div class="annotation u-mt-2">左から詰めて入力してください。スペースは、必要ありません。</div>
                        </div>
                        <label for="holdername">ご契約者名</label>
                        <div class="input-wrapper">
                            <input type="text" id="holdername" class="browser-default c-input-text" inputmode="text" autocomplete="cc-name"
                                    placeholder="TARO GRAJAPA" required="required" :class="{'is-error': !newCardValids.holdername.isValid && isCheckNewCard}"
                                    data-cy="payment-item_purchase-holdername">
                            <div class="annotation is-error u-mt-2" v-if="!newCardValids.holdername.isValid && isCheckNewCard">50文字以内の半角英字で入力してください。</div>
                        </div>
                        <label for="expire_month">有効期限</label>
                        <div class="input-wrapper">
                            <div class="expire-date-container">
                                <select id="expire_month" class="browser-default" name="month" tabindex="-1" data-cy="payment-item_purchase-expire_month" :class="{'is-error': !newCardValids.expire.isValid && isCheckNewCard}">
                                    <option value="">月</option>
                                    <option value="01">1</option>
                                    <option value="02">2</option>
                                    <option value="03">3</option>
                                    <option value="04">4</option>
                                    <option value="05">5</option>
                                    <option value="06">6</option>
                                    <option value="07">7</option>
                                    <option value="08">8</option>
                                    <option value="09">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                </select>
                                <select id="expire_year" class="browser-default" name="year" tabindex="-1" data-cy="payment-item_purchase-expire_year" :class="{'is-error': !newCardValids.expire.isValid && isCheckNewCard}">
                                    <option value="">年</option>
                                    <option v-for="year in cardYears" :value="year">{{ year }}</option>
                                </select>
                            </div>
                            <div class="annotation is-error u-mt-2" v-if="!newCardValids.expire.isValid && isCheckNewCard">有効期限を選択してください。</div>
                            <div class="annotation u-mt-2">カードの有効期限は、通常「月／年（西暦下２桁）」で刻印されています。</div>
                        </div>
                        <label for="securitycode">セキュリティコード</label>
                        <div class="input-wrapper">
                            <input id="securitycode" class="browser-default c-input-text" type="text" inputmode="numeric" autocomplete="cc-cord"
                                    maxlength="4" placeholder="0000" required="required" data-cy="payment-item_purchase-securitycode"
                                    :class="{'is-error': !newCardValids.securitycode.isValid && isCheckNewCard}">
                            <div class="annotation is-error u-mt-2" v-if="!newCardValids.securitycode.isValid && isCheckNewCard">3又は4桁の数字の半角数字で入力してください。</div>
                            <div class="annotation u-mt-2">主にカードの裏面のご署名横に印刷されている３桁ないし４桁の数字です。</div>
                        </div>
                    </div>
                </form>
            </div>
            <div  v-show="is_possible_carrier" class="payment-method-block js-payment-method">
                <div class="payment-method-radio-block">
                    <input id="radio-other" class="c-input-radio" name="other_method" :value="true" type="radio" v-model="other_check">
                    <label for="radio-other" :class="{'payment-type-accordion other-payment-type-accordion' : selected_payment !== 'other_check'}">
                        <div class="payment-method-name">その他支払い</div>
                        <div class="payment-method-sub-info">(コード決済・キャリア決済)</div>
                    </label>
                </div>
                <div class="payment-method-block-detail">
                    <div class="other-payment-methods" v-show="other_check">
                        <div class="payment-method-radio-block" v-for="(method, method_key) in linkTypeCodePayment" :key="method.name">
                            <input :id="'radio-' + method_key" name="payment_method"  :value="method.code" v-model="selected_payment" :disabled="method.alert != ''" type="radio" class="c-input-radio">
                            <label :for="'radio-' + method_key" v-html="method.name"></label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="u-mt-8">
                <!-- payment methods -->
                <div v-if="!reserve_flag && !epos_checked && pre_order_method['epospay'] && pre_order_method['epospay']['alert'] == ''" class="banner">
                    <form id="eposRegisterForm" :action="epos_register.registerUrl" method="post">
                        <input :value="epos_register.siteId" type="hidden" name="siteId">
                        <input :value="epos_register.shopId" type="hidden" name="shopId">
                        <input :value="epos_register.ecEpayAffstrId" type="hidden" name="ecEpayAffstrId">
                        <input :value="epos_register.ecEpayAffstrShopId" type="hidden" name="ecEpayAffstrShopId">
                        <input :value="epos_register.successUrl" type="hidden" name="successUrl">
                        <input :value="epos_register.errorUrl" type="hidden" name="errorUrl">
                        <input :value="epos_register.boCode" type="hidden" name="boCode">
                        <input :value="epos_register.sCode" type="hidden" name="sCode">
                        <input :value="epos_register.ondemandOrRecurring" type="hidden" name="ondemandOrRecurring">
                        <input :value="epos_register.transitionBanner" type="hidden" name="transitionBanner">
                        <img v-if="isEposCampaignPeriod()" :src="epos_register.campaignBannerPath" @click="sendEpos">
                        <img v-else :src="epos_register.bannerPath" @click="sendEpos">
                    </form>
                </div>
            </div>
        </div>

        <ErrorModal
        v-if="showErrorModal"
        @agree="reloadConf"
        @close="reloadConf"
        :title="errorModalParam.title"
        :message="errorModalParam.message"
        ok-message="閉じる"></ErrorModal>
    </div>
</template>

<script>
import routeMixin   from '../../../mixins/route.js';
import ConfirmModal from '../../../components/modal-window/Modal.vue'
import ErrorModal   from '../../../components/modal-window/Modal.vue'
import axios        from 'axios';

export default {
    components:{
        ConfirmModal,
        ErrorModal,
	},
    props: [
        'route_list',
        'registed_card_number',
        'gmo_shop_id',
        'reserve_flag',
        'pre_order_method',
        'is_linktype_adult_filterd',
        'epos_checked',
        'epos_register',
        'item_detail_url',
        'carrier_payment_history',
        'is_possible_carrier',
        'is_adult_content_included',
        'is_brand_limit_adult',
    ],
    mixins: [routeMixin],
	data () {
        return {
            other_check      : false,
            selected_payment : '',
            accept_code      : '',
            order_id         : '',
            endAuthCredit    : false,
            isAuthCredit     : false,
            loading          : false,
            deletedMembers   : null,
            isShow           : true,
            showErrorModal   : false,
            isCheckNewCard   : false,
            isNewCardAdultLimitBrand : false,
            cardYears        : [],
            errorModalParam  : {
                title          : "",
                message        : "",
                ok_message     : null,
                cancel_message : null,
            },
            newCardValids : {
                cardno : {
                    isValid : false,
                    regex   : /^[\d]{10,16}$/
                },
                expire : {
                    isValid : false,
                    regex   : /^\d{4}$|^\d{6}$/
                },
                securitycode : {
                    isValid : false,
                    regex   : /^[\d]{3,4}$/
                },
                holdername : {
                    isValid : false,
                    regex   : /^[a-zA-Z\d ,.\-/]{1,50}$/
                },
            },
            error_messate : null,
        }
    },
    created() {
        let thisYear = Number(new Date().getFullYear());
        let yearInterval = 10;
        let maximumYear = thisYear + yearInterval;
        while (thisYear <= maximumYear){
            this.cardYears.push(thisYear.toString().substr(-2));
            thisYear++;
        }
    },
    mounted() {
        // グローバルイベントリスナーを登録（production対応）
        window.addEventListener('pre-order-method-submit', this.submit);
        this.selected_payment = this.initRadioCheck()
    },
    beforeUnmount() {
        // クリーンアップ
        window.removeEventListener('pre-order-method-submit', this.submit);
    },
    watch: {
        endAuthCredit: function (val) {
            if (val && this.isAuthCredit) {
                this.execPayment();
            }
        },
        selected_payment: function (val) {
            if ((val === 'registed_card' || val === 'new_card') && this.other_check) {
                this.other_check = false;
            }
            if (val === 'AcceptPaymentPaypay' || val === 'AcceptPaymentDocomo' || val === 'AcceptPaymentAu' || val === 'AcceptPaymentSoftbank') {
                this.accept_code = '';
                this.order_id = '';
                for (const history of this.carrier_payment_history) {
                    if (val == history.payment_method) {
                        if (history.accept_code != '' && history.accept_order_id != '')  {
                            this.accept_code = history.accept_code;
                            this.order_id = history.accept_order_id;
                        }
                    }
                }
            }
        },
        other_check: function (val) {
            if (val === true) {
                this.newCardValids.cardno.isValid = true;
                this.newCardValids.expire.isValid = true;
                this.newCardValids.securitycode.isValid = true;
                this.newCardValids.holdername.isValid = true;

                this.selected_payment = '';
                if (this.carrier_payment_history.length < 1) {
                    this.selected_payment = 'AcceptPaymentPaypay';
                } else {
                    for (const history of this.carrier_payment_history) {
                        if (history.payment_method == 'AcceptPaymentPaypay') {
                            this.selected_payment = 'AcceptPaymentPaypay';
                            break;
                        } else if (history.payment_method == 'AcceptPaymentDocomo') {
                            this.selected_payment = 'AcceptPaymentDocomo';
                            break;
                        } else if (history.payment_method == 'AcceptPaymentAu') {
                            this.selected_payment = 'AcceptPaymentAu';
                            break;
                        } else if (history.payment_method == 'AcceptPaymentSoftbank') {
                            this.selected_payment = 'AcceptPaymentSoftbank';
                            break;
                        }
                    }
                }
            }
        }
    },
    computed: {
        linkTypeCodePayment: function () {
            let linkType = {};
            for(let key in this.pre_order_method) {
                // EPOSだけ別のため、それ以外を取り出す(v-for と v-ifは共存できない)
                if (key !== 'epospay') {
                    linkType[key] = this.pre_order_method[key];
                }
            }
            return linkType;
        }
    },
    methods: {
        getdoubleDigestNum(number) {
            return ("0" + number).slice(-2)
        },
        reloadConf: function() {
            location.reload();
        },
        viewError: function(error_code = '---') {
            this.openErrorModal("エラーが発生しました","もう一度お試しください。");
        },
        runLoading: function() {
            this.loading = true;
        },
        viewTokenError: function(resultCode) {
            if (Number(resultCode) <= 201) {
                this.openErrorModal("正しいカード情報が確認できませんでした。","カード情報を再入力してください。");
            } else {
                this.viewError();
            }
        },
        openErrorModal: function (title, message) {
            this.loading               = false;
            this.errorModalParam.title   = title;
            this.errorModalParam.message = message;
            this.showErrorModal          = true
        },
        submit: function () {
            if (this.loading == true) {
                // ローディングが出ている＝処理中、なので無視する
                return;
            }
            this.endAuthCredit  = false;
            this.isAuthCredit   = false;
            this.deletedMembers = null;

            switch (this.selected_payment) {
                case "":
                    this.openErrorModal("お支払方法が選択されていません。", "お支払方法を選択してください。");
                    break;
                case "new_card":
                    let cardno  = document.getElementById("cardno").value.replace(/\s+/g, "");
                    let expire  = document.getElementById("expire_year").value + document.getElementById("expire_month").value;
                    let code    = document.getElementById("securitycode").value;
                    let name    = document.getElementById("holdername").value;
                    let isValid = this.validatetNewCard(cardno, expire, code, name);
                    if (!isValid) {
                        setTimeout(() => {
                            let buttons = document.body.querySelectorAll('.js-purchase-button');
                            buttons.forEach(element => {
                            element.addEventListener('click', submitPurchase);
                        });
                        }, 3000);
                        break;
                    }
                    this.runLoading();
                    this.authCredit(cardno, expire, code, name);
                    break;
                case "registed_card":
                    this.runLoading();
                    this.resetCreditToken();
                    this.execPayment(true);
                    break;
                case "AcceptPaymentDocomo":
                case "AcceptPaymentAu":
                case "AcceptPaymentSoftbank":
                case "AcceptPaymentPaypay":
                    this.runLoading();
                    this.getConsentForUse();
                    break;
            }
        },
        getConsentForUse : function() {
            // グローバルで読み込まれたreCAPTCHAのメソッドを呼び出す
            try {
                grecaptcha.enterprise.ready(() => {
                    try {
                        grecaptcha.enterprise.execute(re_captcha_token, {action: 'plus_register'}, self).then((token) => {
                            this.validateRecaptchaResponse(token);
                        }).catch(() => {
                            this.validateRecaptchaResponse();
                        });
                    } catch (e) {
                        this.validateRecaptchaResponse();
                    }
                });
            } catch (e) {
                this.validateRecaptchaResponse();
            }
        },
        validateRecaptchaResponse : function(token = null) {
            // 随時決済を行うために必要な利用承諾画面に遷移する
            let self = this;
            // 遷移時にどのキャリアを選択したかを引数として渡す
            axios.post(
                '/api/reserve/validateRecaptchaResponse',
                {'mobileCarrier': self.selected_payment, 'g-recaptcha-response': token}
            )
                .then(res => {
                    let data = res.data;
                    // 正常時は利用承諾へリダイレクト
                    if (data.result === 'success') {
                        self.viewAcceptConsent(data.mobileCarrier);
                    }
                    // 異常時はエラー画面にエラーコードを渡してリダイレクト
                    if (data.result === 'error') {
                        self.viewError(data.ErrInfo);
                    }
                })
                .catch(error => {
                    const data = error.response.data;
                    if (data.errors && data.errors.reCAPTCHA_SCORE) {
                        self.openErrorModal("登録に失敗しました。", data.errors.reCAPTCHA_SCORE[0]);
                    } else {
                        self.viewError();
                    }
                });
        },
        // キャリア随時決済の利用承諾画面へ遷移する
        viewAcceptConsent: function(mobileCarrier) {
            window.location.href = this.route(this.route_list, 'site.acceptCodeRequest', {'mobile_carrier': mobileCarrier, 'item_detail_url': this.item_detail_url, 'accept_code': this.accept_code, 'order_id': this.order_id});
        },
        validatetNewCard: function (inp_cardno, inp_expire, inp_code, inp_name) {
            if (this.is_adult_content_included) {
                this.isNewCardAdultLimitBrand = this.isAdultLimitBrandByCardNum(inp_cardno);
                if (this.isNewCardAdultLimitBrand) { 
                    return false;
                }
            }

            let cardValids = this.newCardValids;
            let isValidNo  = cardValids.cardno.regex.test(inp_cardno);
            let isValidEx  = cardValids.expire.regex.test(inp_expire);
            let isValidCo  = cardValids.securitycode.regex.test(inp_code);
            let isValidNa  = cardValids.holdername.regex.test(inp_name);

            cardValids.cardno.isValid       = isValidNo;
            cardValids.expire.isValid       = isValidEx;
            cardValids.securitycode.isValid = isValidCo;
            cardValids.holdername.isValid   = isValidNa;

            this.isCheckNewCard = true;

            return (isValidNo && isValidEx && isValidCo && isValidNa);
        },
        isAdultLimitBrandByCardNum: function (cardno) {
            const isVisa   = /^4/.test(cardno);
            const isMaster = /^5[1-5]/.test(cardno) || /^2(22[1-9]|2[3-9]\d|[3-6]\d{2}|7[01]\d|720)\d/.test(cardno);
            return isVisa || isMaster;
        },
        authCredit: function (cardno, expire, securitycode, holdername) {
            let self         = this;
            let tokennumber  = 3;

            Multipayment.init(this.gmo_shop_id);
            Multipayment.getToken({
                cardno       : cardno,
                expire       : expire,
                securitycode : securitycode,
                holdername   : holdername,
                tokennumber  : tokennumber
            }, function(response) {
                let resultCode = response.resultCode;
                if (resultCode === "000") {
                    axios.post(self.route(self.route_list, 'site.api.payment.saveCreditToken'), response.tokenObject.token)
                    .then(res => {
                        if (res.status == 200) {
                            // グローバルで読み込まれたreCAPTCHAのメソッドを呼び出す
                            try {
                                grecaptcha.enterprise.ready(function () {
                                    try {
                                        grecaptcha.enterprise.execute(re_captcha_token, {action: 'card_register'}).then(function (token) {
                                            self.gmoAuth(token);
                                        }).catch(function () {
                                            self.gmoAuth();
                                        });
                                    } catch (e) {
                                        self.gmoAuth();
                                    }
                                });
                            } catch (e) {
                                self.gmoAuth();
                            }
                        } else {
                            self.viewError();
                        }
                    })
                    .catch(error => {
                        self.viewError();
                    });
                } else {
                    self.viewTokenError(resultCode);
                }
            });
        },
        gmoAuth : function(token = null) {

            let self = this;
            axios.post(self.route(self.route_list, 'site.api.payment.pre_order.gmoAuthCreditPayment'), {'g-recaptcha-response': token, 'item_detail_url': self.item_detail_url})
            .then(res => {
                if (res.status == 200) {
                    let data = res.data;
                    if (data.result === 'success') {
                        self.deletedMembers = data.deleted_members;
                        self.isAuthCredit = true;
                    } else if (data.ErrorMessage === "カード重複エラー") {
                        self.openErrorModal("このカードはご利用になれません。", "別のカード情報を入力してください。");
                    } else if (data.method === "gmoSaveCard" && data.ErrCd === "E61|") {
                        self.openErrorModal("カード情報の登録に失敗しました。", "正しいカード情報を入力してください。");
                    } else if (data.method === "getExecTran" && data.ErrCd === "E01|") {
                        self.openErrorModal("カード情報の登録に失敗しました。", "正しいカード情報を入力してください。");
                    } else if (data.ErrInfo === 'brand_limit') {
                        self.openErrorModal("このカードはご利用になれません。", data.ErrorMessage);
                    } else {
                        self.viewError(data.ErrInfo);
                    }
                } else {
                    self.viewError();
                }
                self.endAuthCredit = true;
            })
            .catch(error => {
                const data = error.response.data;
                if (data.errors && data.errors.reCAPTCHA_SCORE) {
                    self.openErrorModal("カード情報の登録に失敗しました。", data.errors.reCAPTCHA_SCORE[0]);
                } else {
                    self.viewError();
                }
            });
        },
        execPayment : function(use_registed_card) {
            var form = document.createElement('form');
            form.method = "POST";
            form.action = this.route(this.route_list, 'site.item.pre_order.createPreOrder');

            // CSRF設定
            var request = document.createElement('input');
            request.type = 'hidden';
            request.name = '_token';
            request.value = document.getElementsByName('csrf-token')[0].content;
            form.appendChild(request);

            // 商品IDを設定
            var item = document.createElement('input');
            item.type = 'hidden';
            item.name = 'item_detail_url';
            item.value = this.item_detail_url;
            form.appendChild(item);

            if (use_registed_card) {
                var registed_card = document.createElement('input');
                registed_card.type = 'hidden';
                registed_card.name = 'is_registed_card';
                registed_card.value = 1;
                form.appendChild(registed_card);
            }

            // グローバルで読み込まれたreCAPTCHAのメソッドを呼び出す
            try {
                grecaptcha.enterprise.ready(function () {
                    try {
                        grecaptcha.enterprise.execute(re_captcha_token, {action: 'payment'}).then(function (token) {
                            let recaptcha = document.createElement('input');
                            recaptcha.type = 'hidden';
                            recaptcha.name = 'g-recaptcha-response';
                            recaptcha.value = token;
                            form.appendChild(recaptcha);
                            document.querySelector('.js-payment-method').appendChild(form);
                            form.submit();
                        }).catch(function () {
                            document.querySelector('.js-payment-method').appendChild(form);
                            form.submit();
                        });
                    } catch (e) {
                        document.querySelector('.js-payment-method').appendChild(form);
                        form.submit();
                    }
                });
            } catch (e) {
                document.querySelector('.js-payment-method').appendChild(form);
                form.submit();
            }
        },
        sendEpos : function() {
            document.querySelector('#eposRegisterForm').submit();
        },
        initRadioCheck : function() {
            if (this.is_brand_limit_adult) {
                return 'new_card';
            }
            if (this.registed_card_number) {
                return 'registed_card';
            } else if (!this.registed_card_number && this.carrier_payment_history.length > 0) {
                this.other_check = true;
            } else {
                return 'new_card';
            }
        },
        // エポス新規入会キャンペーン期間中であればtrue
        isEposCampaignPeriod : function() {
            let now = new Date();
            let campaign_start_date = new Date(2022, 1, 1, 12, 0, 0);
            let campaign_end_date = new Date(2022, 2, 31, 23, 59, 59);
            // 現在時刻が 2022/02/01 12:00:00 ~ 2022/03/31 23:59:59 以外であればfalse
            if (now < campaign_start_date || campaign_end_date < now) {
                return  false;
            }
            return true;
        },
        resetCreditToken : function() {
            let url = this.route(this.route_list, 'site.api.deleteCreditToken');
            axios.post(url, {
            }).then(res => {
            }).catch(error => {
                self.openErrorModal("予約に失敗しました。", "ページを更新して再度予約をお試し下さい");
            });
        }
    }
}
</script>

<style lang="scss" scoped>
label {
    color: var(--gj-text-color);
    font-size: 13px;
}

.payment-method-block {
    border: 1px solid var(--gj-border-color);
    background: var(--gj-color-white);
    padding: 16px;

    &:not(:first-of-type) {
        border-top: none;
    }
    .payment-method-radio-block {
        display: flex;
        align-items: center;
        gap: 8px;
        color: var(--gj-text-color);

        .payment-method-name {
            font-size: 14px;
            font-weight: 600;
            line-height: 130%;
        }
        .payment-method-sub-info {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 300;
            line-height: 130%;
        }
    }
}
.payment-method-block-detail {
    margin-inline: 36px;
    margin-top: 8px;

    .credit-card-image {
        width: 200px;
    }
}
.new-credit-card-form {
    --input-margin-bottom: 16px;
    --input-width: 100%;
    --label-margin-top: 0;
    margin-top: 24px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(max-content);
    column-gap: 16px;
    row-gap: 4px;
    font-size: 13px;
    font-weight: 300;
    color: var(--gj-text-color-light);
    place-items: start start;
    justify-items: stretch;

    label {
        margin-top: var(--label-margin-top);
        color: var(--gj-color-light-grey);
    }
    .input-wrapper {
        margin-bottom: var(--input-margin-bottom);
    }
    .expire-date-container {
        width: var(--input-width);
        display: flex;
        justify-content: space-between;
        gap: 8px;

        > select {
            flex: 1 1 auto;
        }
    }
    input {
        width: var(--input-width);
        margin-bottom: 0;
        height: unset;

        &.is-error {
            border-color: var(--gj-color-red);
        }
    }
    select {
        position: relative;
        padding: 8px 48px 8px 16px;
        border: 1px solid var(--gj-border-color);
        appearance: none;
        background-image: url("/src/assets/img/common/icon-stroke-down-black.svg");
        background-position: right 4px top 2px;
        background-repeat: no-repeat;
        height: unset;
        font-size: 13px;

        &.is-error {
            border-color: var(--gj-color-red);
        }
    }


    @media (min-width: 768px) {
        --input-margin-bottom: 0;
        --input-width: 182px;
        --label-margin-top: 12px;

        grid-template-columns: max-content 1fr;
        grid-template-rows: repeat(max-content);
        row-gap: 24px;
        justify-items: start;
    }
}

.annotation {
    font-size: 10px;
    font-weight: 300;
    line-height: 130%;
    &.is-error {
        color: var(--gj-color-red);
    }
}

.other-payment-methods {
    padding-block: 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#eposRegisterForm {
    margin-left: 30px;
    width: 400px;
    @media screen and (max-width: 767px) {
        width: 80%;
    }
    img {
        cursor: pointer;
    }
}
</style>
